//
//
//
//
//
//

var Mapper = {};
var script = {
  name: 'PtAccordion',
  props: {
    closeOthersOnHeaderClick: {
      type: Boolean,
      default: true,
    },
    keepFirstItemOpenOnLoad: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    onAccordionItemClick: function onAccordionItemClick(identifier) {
      var this$1 = this;

      if (this.closeOthersOnHeaderClick) {
        var keys = Object.keys(Mapper);

        keys.forEach(function (key) {
          if (key !== identifier) {
            this$1.$children.forEach(function (child) {
              if (child.identifier !== identifier && child.isOpen) {
                Mapper[key] = false;
                child.closeItem();
              }
            });
          }
        });
      }

      Mapper[identifier] = !Mapper[identifier];

      var itemTogglePayload = {};
      itemTogglePayload[identifier] = Mapper[identifier];

      this.$emit(("on-accordion-item-" + (Mapper[identifier] ? 'open' : 'close')), itemTogglePayload);
    },
    registerChild: function registerChild(identifier) {
      var status = !Object.keys(Mapper).length && this.keepFirstItemOpenOnLoad;
      Mapper[identifier] = status;

      return status;
    },
  },
};

function normalizeComponent(compiledTemplate, injectStyle, defaultExport, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, isShadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof isShadowMode === 'function') {
        createInjectorSSR = createInjector;
        createInjector = isShadowMode;
        isShadowMode = false;
    }
    // Vue.extend constructor export interop
    const options = typeof defaultExport === 'function' ? defaultExport.options : defaultExport;
    // render functions
    if (compiledTemplate && compiledTemplate.render) {
        options.render = compiledTemplate.render;
        options.staticRenderFns = compiledTemplate.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (injectStyle) {
                injectStyle.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (injectStyle) {
        hook = isShadowMode
            ? function () {
                injectStyle.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
            }
            : function (context) {
                injectStyle.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return defaultExport;
}

/* script */
            var __vue_script__ = script;
            
/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "pt-accordion-container",
      on: { accordionItemClick: _vm.onAccordionItemClick }
    },
    [_vm._t("default")],
    2
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  var __vue_inject_styles__ = undefined;
  /* scoped */
  var __vue_scope_id__ = undefined;
  /* module identifier */
  var __vue_module_identifier__ = undefined;
  /* functional template */
  var __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Accordion = normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

var holder = {};

var randomNumberGenerator = function (key) {
  if (!key) {
    return null;
  }

  var randomId = '';

  while (true) {
    randomId = Math.random().toString(36).substring(6);

    if (!holder[key] || holder[key].indexOf(randomId) === -1) {
      holder[key] = holder[key] || [];
      holder[key].push(randomId);
      break;
    }
  }

  return (key + "-" + randomId);
};

//

var script$1 = {
  name: 'PtAccordionItem',
  props: {
    showPointerIconInHeader: {
      type: Boolean,
      default: true,
    },
    openIcon: {
      type: String,
      default: 'fa-angle-up',
    },
    closeIcon: {
      type: String,
      default: 'fa-angle-down',
    },
    iconPosition: {
      type: String,
      default: 'left',
    },
  },
  data: function data() {
    var identifier = randomNumberGenerator('accordion-item');
    return {
      identifier: identifier,
      isOpen: false,
    };
  },
  mounted: function mounted() {
    this.isOpen = this.$parent.registerChild(this.identifier);
  },
  methods: {
    onHeaderClick: function onHeaderClick() {
      this.$parent.onAccordionItemClick(this.identifier);
      this.toggleVisibility();
    },
    toggleVisibility: function toggleVisibility() {
      if (this.isOpen) {
        this.closeItem();
      } else {
        this.openItem();
      }
    },
    openItem: function openItem() {
      this.isOpen = true;
    },
    closeItem: function closeItem() {
      this.isOpen = false;
    },
  },
};

/* script */
            var __vue_script__$1 = script$1;
            
/* template */
var __vue_render__$1 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "pt-accordion-item-container",
      class: { "pt-accordion-item-closed": !_vm.isOpen }
    },
    [
      _c(
        "div",
        {
          staticClass: "pt-accordion-item-container__header",
          class: {
            "pt-accordion-header-default__open": _vm.isOpen,
            "justify-between": _vm.iconPosition === "right"
          },
          on: { click: _vm.onHeaderClick }
        },
        [
          _vm.iconPosition && _vm.iconPosition === "left"
            ? _c("div", [
                _vm.showPointerIconInHeader
                  ? _c("i", {
                      staticClass: "fa pt-accordion-header-icon",
                      class: [_vm.isOpen ? _vm.openIcon : _vm.closeIcon]
                    })
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._t("accordion-header", [
            _c("div", [_vm._v("This is my header")])
          ]),
          _vm._v(" "),
          _vm.iconPosition && _vm.iconPosition === "right"
            ? _c("div", [
                _vm.showPointerIconInHeader
                  ? _c("i", {
                      staticClass: "fa pt-accordion-header-icon",
                      class: [_vm.isOpen ? _vm.openIcon : _vm.closeIcon]
                    })
                  : _vm._e()
              ])
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pt-accordion-item-container__body" },
        [
          _vm.isOpen
            ? _vm._t("accordion-body", [
                _c("div", { staticClass: "pt-accordion-body-default" }, [
                  _vm._v("\n          This is my content\n        ")
                ])
              ])
            : _vm._e()
        ],
        2
      )
    ]
  )
};
var __vue_staticRenderFns__$1 = [];
__vue_render__$1._withStripped = true;

  /* style */
  var __vue_inject_styles__$1 = undefined;
  /* scoped */
  var __vue_scope_id__$1 = undefined;
  /* module identifier */
  var __vue_module_identifier__$1 = undefined;
  /* functional template */
  var __vue_is_functional_template__$1 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var AccordionItem = normalizeComponent(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    undefined,
    undefined
  );

export { Accordion as PtAccordion, AccordionItem as PtAccordionItem };
